export default __webpack_public_path__ + "static/media/img-07.49edf688.png";